var _circle, _g, _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoIcnCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#1865C1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3554_11786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 17.2L30.213 13.55C30.288 13.4975 30.3759 13.4665 30.4672 13.4605C30.5586 13.4545 30.6498 13.4737 30.731 13.516C30.8122 13.5583 30.8802 13.6221 30.9276 13.7004C30.9751 13.7786 31.0001 13.8685 31 13.96V26.04C31.0001 26.1315 30.9751 26.2214 30.9276 26.2996C30.8802 26.3779 30.8122 26.4417 30.731 26.484C30.6498 26.5263 30.5586 26.5455 30.4672 26.5395C30.3759 26.5335 30.288 26.5025 30.213 26.45L25 22.8V27C25 27.2652 24.8946 27.5196 24.7071 27.7071C24.5196 27.8946 24.2652 28 24 28H10C9.73478 28 9.48043 27.8946 9.29289 27.7071C9.10536 27.5196 9 27.2652 9 27V13C9 12.7348 9.10536 12.4804 9.29289 12.2929C9.48043 12.1054 9.73478 12 10 12H24C24.2652 12 24.5196 12.1054 24.7071 12.2929C24.8946 12.4804 25 12.7348 25 13V17.2ZM25 20.359L29 23.159V16.84L25 19.64V20.358V20.359ZM11 14V26H23V14H11ZM13 16H15V18H13V16Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9.80078,
    width: 2,
    height: 30,
    transform: "rotate(-45 9 9.80078)",
    fill: "#1865C1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 10.8008,
    width: 2,
    height: 30,
    transform: "rotate(-45 8 10.8008)",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3554_11786"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcnCross);
export default __webpack_public_path__ + "static/media/video-icn-cross.f6cbc5613f737b3729837054da5523e6.svg";
export { ForwardRef as ReactComponent };